import React, { useEffect, lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import ManagementDashboard from './pages/ManagementDashboard/ManagementDashboard';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Activate from './pages/Activate/Activate';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import SocialLoginCallback from './pages/SocialLoginCallback/SocialLoginCallback';
import { initAuthToken } from './services/apiClient';
import EmailRegisterPage from './pages/Register/EmailRegisterPage';
import VerifyOTPPage from './pages/Register/VerifyOTPPage';
import CompletePage from './pages/Register/CompleteRegistrationPage';
import ForgotPasswordPage from './pages/Auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/Auth/ResetPasswordPage';
import TwoFARecoveryPage from './pages/TwoFARecovery/Recovery';
import TwoFAResetPage from './pages/TwoFAResetPage/TwoFAResetPage';
import SubscriptionSuccess from './pages/subscription/Success';
import SubscriptionCancel from './pages/subscription/Cancel';
import SubscriptionUpdate from './pages/subscription/Update';
import Instruction from './pages/Instruction/Instruction';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Service from './pages/Service/Service';
import Tokushoho from './pages/Tokushoho/Tokushoho';
import Contact from './pages/Contact/Contact';


// Lp ページを動的 import
const Lp = lazy(() => import('./pages/Lp/Lp'));

const Canonical = () => {
  const { pathname } = useLocation();
  return (
    <Helmet>
      <link rel="canonical" href={`https://auto-chat.ai${pathname}`} />
    </Helmet>
  );
};

// Lp2 ページを動的 import
const Lp2 = lazy(() => import('./pages/Lp2/Lp2'));


function App() {
  useEffect(() => {
    initAuthToken();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <Canonical />
        <Suspense fallback={<div></div>}>
          <Routes>
            {/* LP（トップページ） */}
            <Route path="/lp" element={<Lp />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="/lp_night" element={<Lp2 />} />

            {/* 認証が必要なページ */}
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <ManagementDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription/success"
              element={
                <PrivateRoute>
                  <SubscriptionSuccess />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription/cancel"
              element={
                <PrivateRoute>
                  <SubscriptionCancel />
                </PrivateRoute>
              }
            />
            <Route
              path="/subscription/update"
              element={
                <PrivateRoute>
                  <SubscriptionUpdate />
                </PrivateRoute>
              }
            />

            <Route
              path="/instruction"
              element={
                <PrivateRoute>
                  <Instruction />
                </PrivateRoute>
              }
            />

            {/* 未認証ユーザー用 */}
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/2fa/recovery"
              element={
                <PublicRoute>
                  <TwoFARecoveryPage />
                </PublicRoute>
              }
            />
            <Route
              path="/2fa/reset"
              element={
                <PublicRoute>
                  <TwoFAResetPage />
                </PublicRoute>
              }
            />
            <Route
              path="/register/email"
              element={
                <PublicRoute>
                  <EmailRegisterPage />
                </PublicRoute>
              }
            />
            <Route
              path="/register/verify"
              element={
                <PublicRoute>
                  <VerifyOTPPage />
                </PublicRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicRoute>
                  <Register />
                </PublicRoute>
              }
            />
            <Route
              path="/activate"
              element={
                <PublicRoute>
                  <Activate />
                </PublicRoute>
              }
            />
            <Route path="/register/complete" element={<CompletePage />} />
            <Route
              path="/password-reset"
              element={
                <PublicRoute>
                  <ForgotPasswordPage />
                </PublicRoute>
              }
            />
            <Route
              path="/password-reset/confirm"
              element={<ResetPasswordPage />}
            />
            {/* ソーシャルログインコールバック */}
            <Route path="/social-login" element={<SocialLoginCallback />} />

            {/* それ以外はログインへ */}
            <Route path="*" element={<Navigate to="/login" replace />} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<Service />} />
            <Route path="/tokushoho" element={<Tokushoho />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
}

export default App;